import React, { Component } from 'react'
import Display from '../../../../v2SPRINTA/atoms/Display'


import { FluidContainer, Row, Col, Container } from '../../../../v2SPRINTA/atoms/Grid'
import CoverImage from '../../../../SPRINTA/atoms/CoverImage'
import AspectRatio  from '../../../../SPRINTA/atoms/AspectRatio'
import Avatar  from '../../../../SPRINTA/atoms/Avatar'
import FontIcon  from '../../../../SPRINTA/atoms/FontIcon'
import Slider from '../../../../v2SPRINTA/third-party/Slider'
import Button from '../../../../v2SPRINTA/atoms/Button'
// import Modal from '../../../../v2SPRINTA/atoms/Modal'
import ModalHash from '../../../../v2SPRINTA/atoms/ModalHash'


// import ScrollTo from '../../../../SPRINTA/atoms/ScrollTo'


import css from './style.module.css'
class Institucional extends Component {
    state = {
        experiences: [
            {
                title: 'Rafael é publicitário organiza experiências de cicloturismo',
                cover: require('./bannerA1_Fundo.png'),
                avatar: require('./avatar_Rafael.png'),
                content: `
                    <p>
                        O publicitário e ciclista Rafael criou durante suas horas vagas uma experiência que une seu hobby, a beleza da cidade e seu espírito empreendedor: cicloturismo em Porto Alegre.
                    </p>
                    <p>
                        Atualmente Rafael reúne diversos ciclistas aos finais de semana para conhecer a história da cidade em seus principais pontos turísticos através de uma volta de bicicleta, possibilitando diversão, cultura local e o complemento da sua renda com um ganho extra no final
                        do mês.
                    </p>
                `
            },
            {
                title: 'Laura é professora e oferece aulas de slackline em São Paulo',
                cover: require('./bannerA2_Fundo.png'),
                avatar: require('./avatar_Laura.png'),
                content: `
                    <p>
                    A professora de Educação Física Laura apresenta o Slackline para diversas pessoas através de uma experiência no parque do Ibirapuera, em São Paulo.
                    </p>
                    <p>
                    Laura começou a praticar o Slackline através de amigos em comum e hoje se tornou uma das influências do esporte. <br>
                    Aproveitou a compra do equipamento e agenda livre para apresentar e ensinar às pessoas a vida sob um fio, criando experiências no maior parque de São Paulo, resultando no aumento da sua renda mensal.
                    </p>
                `
            },
            {
                title: 'Matheus é surfista e oferece aulas de surfe em Floripa',
                cover: require('./bannerA3_Fundo.png'),
                avatar: require('./avatar_Matheus.png'),
                content: `
                    <p>
                    O surfista Matheus, que faz um açaí delicioso, criou uma experiência para turistas curiosos em descobrir o surfe.
                    </p>
                    <p>
                    Matheus nasceu em Floripa e sempre amou o mar. Preparando açaí na praia da Joaquina, viu que os turistas ficavam no quiosque assistindo aos surfistas e se perguntando como faziam aquelas manobras. Matheus então montou uma experiência que ajuda e ensina aos turistas a experimentarem o surfe pela primeira vez e quem sabe arriscar algumas manobras.
                    </p>
                `
            },
            {
                title: 'Christian é personal e oferece experiências de treinos exclusivas',
                cover: require('./bannerA5_Fundo.png'),
                avatar: require('./avatar_Christian.png'),
                content: `
                    <p>
                    Exercícios repetitivos, treinadores desinteressados e preços mensais: isto afasta qualquer um da academia, percebia Christian ao frequentar as academias. Vendo estas dificuldades dos alunos, Christian acabou criando experiências de treinos individuais em diversas academias do Rio de Janeiro, possibilitando flexibilidade para seus alunos, tanto no pagamento quanto na frequência.
                    </p>
                `
            },
        ],
        opened: 0,
        next: 1,
        before: 3
    }

    contentChange(type) {
        let timing = 0
        if(this.refs.modal.refs.scrollable.scrollTop > 0) {
            timing = 300
            this.refs.modal.refs.scrollable.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
        
        setTimeout(() => {
            this.handleModalContent(this.state[type])
        }, timing)
    }


    listener(e) {
        let keyCode = e.keyCode;
        if(keyCode === 39) {
            this.contentChange('next')
        }

        if(keyCode === 37) {
            this.contentChange('before')
        }
    }

    closeModal() {
        this.setState({
            opened: null
        })

        window.history.pushState("", document.title, window.location.pathname);

        document.removeEventListener('keydown', this.listener.bind(this))
    }

    handleModalContent(key) {

        if(this.state.opened === null)
        document.addEventListener('keydown', this.listener.bind(this))

        let opened = key
        let next = key + 1
        let before = key - 1

        if(before < 0)
        before = this.state.experiences.length - 1

        if(next >= this.state.experiences.length)
        next = 0

        this.setState({
            opened,
            next,
            before
        }, () => {
            window.location.hash = '#inspiration'
        })
    }

    render() {
        return (
            <FluidContainer>
                <Row>
                    <CoverImage
                        image={require('./top_banner.jpg')}
                        shadow='300'
                        style={{ backgroundColor: '#333', color: '#fff' }}>
                        <Container>
                            
                            <Row alignItems='center' justifyContent="center"  style={{ paddingTop: '100px' }}>
                                <Col size='12 12 11' text='center'>
                                    <Display heading size={1}>Ofereça <b>experiências</b> únicas</Display>
                                    <br />

                                    <Display size={2}>
                                        Crie e compartilhe suas experiências únicas com o mundo e aumente sua renda mensal fazendo o que gosta: esporte
                                    </Display>
                                    <br />
                                </Col>
                                
                                <Col size='12 12 11' text='center' style={{
                                        marginTop: '180px',
                                        marginBottom: '10px'
                                }}>
                                    <Display size={3}>
                                        Antes de tudo, <b>veja alguns exemplos</b> para te inspirar
                                    </Display>
                                </Col>
                            </Row>

                            <Row justifyContent='center'>
                                <Col size='12 12 10'  style={{
                                        marginBottom: '60px'
                                }}>
                                    <Slider
                                        light
                                        items={2}
                                    >
                                        {this.state.experiences.map((xp, k) => (
                                            <Col key={k}>
                                                <div className={css.item}>
                                                    <Row>
                                                        <AspectRatio ratio='2x1' image={xp.cover} />
                                                    </Row>
                                                    <Row justifyContent='center' style={{ position: 'relative', marginTop: '-47px' }}>
                                                        <Col size='auto'>
                                                            <Avatar img={xp.avatar} border='4px solid #fff' size='90' />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col size='12' text='center' className={css.content}>
                                                            <Display size={3}>
                                                                <span dangerouslySetInnerHTML={{__html: xp.title }} />
                                                            </Display>
                                                            <div style={{ marginTop: '30px' }}>
                                                                <Button primary inline onClick={() => this.handleModalContent(k)}>Ver história</Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        ))}
                                    </Slider>
                                </Col>
                            </Row>
                        
                        </Container>

                        
                    </CoverImage>
                </Row>

                <ModalHash
                    hash='#inspiration'
                    ref="modal"
                    style={{ 
                        padding: 0,
                        width: '690px',
                        paddingBottom: '30px'
                    }}
                    content={() => {
                        return (
                            <div>
                                <AspectRatio ratio='2x1' image={this.state.experiences[this.state.opened].cover} />

                                <Col size='12'>
                                    <Row justifyContent='center' style={{ position: 'relative', marginTop: '-47px'}}>
                                        <Col size='10'>
                                            <div style={{ width: '90px' }}>
                                                <Avatar
                                                    img={this.state.experiences[this.state.opened].avatar}
                                                    border='2px solid #fff'
                                                    size='90' />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row justifyContent='center' alignItems='stretch' style={{ paddingTop: '30px' }}>
                                        <Col size='1' text='center' style={{ padding: 0 }}>
                                            <div style={{ height: '100%', cursor: 'pointer',  display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => this.contentChange('before')}>
                                                <FontIcon name='left-arrow' color='#f50' size={20} />
                                            </div>
                                        </Col>
                                        <Col size='9 9 10'>
                                            <Display size={2}><span dangerouslySetInnerHTML={{ __html: this.state.experiences[this.state.opened].title}} /></Display>
                                            <span dangerouslySetInnerHTML={{ __html: this.state.experiences[this.state.opened].content}} />
                                        </Col>
                                        <Col size='1' text='center' style={{ padding: 0 }}>
                                            <div style={{ height: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}  onClick={() => this.contentChange('next')}>
                                                <FontIcon name='right-arrow' color='#f50' size={20} />
                                            </div>
                                        </Col>
                                    </Row>

                                    <hr className={css.divider} />
                                    
                                    <Row justifyContent='center' style={{ marginTop: '30px' }}>
                                    <Col size='12 12 10' style={{ marginBottom: '20px' }}>
                                        <Display size={2}>Mais <b>inpiração</b></Display>
                                    </Col>
                                    <Col size='12 12 10'>
                                        <Row>
                                            <Col size='6' text='center' style={{ cursor: 'pointer' }}>
                                                <div onClick={() => this.contentChange('before')}>
                                                    <div>
                                                        <AspectRatio
                                                            ratio='2x1'
                                                            image={this.state.experiences[this.state.before].cover}
                                                            style={{
                                                                borderRadius: '4px'
                                                            }}
                                                            />
                                                    </div>

                                                    <div style={{ marginTop: '20px' }}>
                                                        <span dangerouslySetInnerHTML={{ __html: this.state.experiences[this.state.before].title }} />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col size='6' text='center' style={{ cursor: 'pointer' }}>
                                                <div onClick={() => this.contentChange('next')}>
                                                    <div>
                                                        <AspectRatio
                                                            ratio='2x1'
                                                            image={this.state.experiences[this.state.next].cover}
                                                            style={{
                                                                borderRadius: '4px'
                                                            }}
                                                            />
                                                    </div>
                                                    <div style={{ marginTop: '20px' }}>
                                                        <span dangerouslySetInnerHTML={{ __html: this.state.experiences[this.state.next].title }} />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                </Col>
                            </div>
                        )
                    }} />

            </FluidContainer>
        )
    }

}

export default Institucional


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Institucional/index.js